// 成全影院 Mock 影片数据

export interface Movie {
  id: number;
  title: string;
  englishTitle: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subcategory: string;
  year: number;
  rating: number;
  poster: string;
  banner: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  episodes: string;
  releaseDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  views: number;
}

export const categories = [
  { id: 'movie', name: '电影', icon: 'ri-film-line' },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { id: 'variety', name: '综艺', icon: 'ri-live-line' },
  { id: 'anime', name: '动漫', icon: 'ri-rocket-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20blue%20and%20orange%20color%20scheme%2C%20movie%20poster%20design%2C%20epic%20scale%2C%20professional%20film%20poster%20photography&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%2C%20massive%20space%20station%20orbiting%20Earth%2C%20dramatic%20nebula%20colors%2C%20cinematic%20wide%20shot%2C%20professional%20film%20photography%2C%20epic%20scale%2C%20dark%20atmosphere%20with%20warm%20highlights&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    description: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的危机。为求生存，人类开启"流浪地球"计划，倾尽所有建造一万座行星发动机，驱使地球逃离太阳系，前往新家园。在这场跨越2500年的壮丽旅程中，人类面临前所未有的挑战与抉择。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    duration: '173分钟',
    episodes: '1集',
    releaseDate: '2026-02-10',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    isHot: true,
    isNew: true,
    views: 8956230,
  },
  {
    id: 2,
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    category: 'movie',
    subcategory: '奇幻',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20mythology%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20epic%20battle%2C%20mythical%20creatures%2C%20golden%20and%20red%20color%20palette%2C%20traditional%20Chinese%20painting%20style%20blend%2C%20cinematic%20film%20poster%20design&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20battle%20scene%2C%20ancient%20warriors%20with%20mythical%20beasts%2C%20dramatic%20sky%2C%20golden%20lighting%2C%20cinematic%20wide%20angle%2C%20professional%20film%20photography%2C%20epic%20scale&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    description: '商朝末年，纣王暴虐无道，姜子牙携封神榜下山，辅佐武王伐纣。仙魔大战一触即发，各方势力明争暗斗，一场关乎天下苍生命运的大战就此展开。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    region: '中国大陆',
    duration: '156分钟',
    episodes: '1集',
    releaseDate: '2026-01-29',
    tags: ['奇幻', '神话', '动作', '史诗'],
    isHot: true,
    isNew: true,
    views: 7834100,
  },
  {
    id: 3,
    title: '哪吒之魔童闹海',
    englishTitle: 'Nezha: The Devil Child Rages',
    category: 'anime',
    subcategory: '动画电影',
    year: 2025,
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20mythological%20character%20Nezha%20with%20fire%20wheel%20and%20red%20sash%2C%20dramatic%20dynamic%20pose%2C%20vibrant%20red%20and%20gold%20colors%2C%20Chinese%20animation%20style%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20animation%20scene%2C%20Nezha%20flying%20through%20stormy%20skies%20with%20fire%20and%20lightning%2C%20vibrant%20colors%2C%20dramatic%20cinematic%20composition%2C%20animated%20film%20style%2C%20epic%20scale&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    description: '天地灵气孕育出一颗混元珠，元始天尊将其炼化为灵珠和魔丸。灵珠投胎为人，助周伐纣；魔丸则会诞出魔王，为祸人间。然而元始天尊的徒弟申公豹从中作梗，本应是灵珠英雄的哪吒却成了混世大魔王。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    region: '中国大陆',
    duration: '110分钟',
    episodes: '1集',
    releaseDate: '2025-07-26',
    tags: ['动画', '神话', '喜剧', '动作'],
    isHot: true,
    isNew: false,
    views: 12560000,
  },
  {
    id: 4,
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: 'tv',
    subcategory: '都市',
    year: 2025,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20style%2C%20elegant%20woman%20in%20cheongsam%2C%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20drama%20poster%20design&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%2C%20neon%20signs%20along%20the%20Bund%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20street%20lights%2C%20cinematic%20wide%20shot%2C%20professional%20photography%2C%20period%20drama%20aesthetic&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    description: '九十年代的上海，煌煌大时代，人人争上游。阿宝由平凡的街头青年，凭借改革开放的春风和自己的打拼，成为黄河路上叱咤风云的宝总。在这条时代大河的浪花里，他与至真园的老板娘李李、外贸公司的汪小姐、夜东京的玲子等人，演绎了一段段跌宕起伏的人生故事。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    duration: '45分钟/集',
    episodes: '30集',
    releaseDate: '2025-12-27',
    tags: ['都市', '年代', '商战', '爱情'],
    isHot: true,
    isNew: false,
    views: 9872000,
  },
  {
    id: 5,
    title: '乘风破浪的姐姐 第六季',
    englishTitle: 'Sisters Who Make Waves S6',
    category: 'variety',
    subcategory: '音乐竞演',
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20confident%20women%20on%20stage%2C%20spotlight%20and%20stage%20lighting%2C%20glamorous%20performance%20aesthetic%2C%20purple%20and%20gold%20color%20scheme%2C%20entertainment%20show%20poster%20design&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Grand%20stage%20performance%20with%20dramatic%20lighting%2C%20concert%20atmosphere%2C%20spotlights%20and%20audience%20silhouettes%2C%20entertainment%20show%20production%2C%20cinematic%20wide%20shot%2C%20professional%20stage%20photography&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    description: '30位30+的姐姐再度集结，开启全新一季的音乐竞演之旅。她们将在舞台上用实力证明，年龄从来不是限制，每个阶段的女性都可以绽放独特的光芒。本季赛制全面升级，更多惊喜舞台等你来见证！',
    director: '芒果TV',
    actors: ['宁静', '那英', '王心凌', '郑秀妍', '于文文'],
    region: '中国大陆',
    duration: '120分钟/期',
    episodes: '12期',
    releaseDate: '2026-05-15',
    tags: ['综艺', '音乐', '竞演', '女性'],
    isHot: true,
    isNew: true,
    views: 6543000,
  },
  {
    id: 6,
    title: '孤注一掷2',
    englishTitle: 'No More Bets 2',
    category: 'movie',
    subcategory: '犯罪',
    year: 2026,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20urban%20alleyway%20with%20silhouette%20figure%2C%20tense%20atmosphere%2C%20red%20neon%20accents%2C%20noir%20style%2C%20suspenseful%20film%20poster%20design&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dark%20urban%20cityscape%20at%20night%20with%20neon%20signs%2C%20rain-slicked%20streets%2C%20mysterious%20atmosphere%2C%20crime%20thriller%20aesthetic%2C%20cinematic%20wide%20shot%2C%20professional%20film%20photography&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    description: '继前作揭露境外诈骗工厂后，本片聚焦新型网络诈骗手段。程序员潘生和模特安娜再次深入虎穴，揭开一个隐藏在暗网深处的庞大犯罪网络。真实案例改编，令人触目惊心。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君', '王大陆'],
    region: '中国大陆',
    duration: '142分钟',
    episodes: '1集',
    releaseDate: '2026-04-01',
    tags: ['犯罪', '剧情', '悬疑', '社会'],
    isHot: false,
    isNew: true,
    views: 4521000,
  },
  {
    id: 7,
    title: '斗罗大陆2：绝世唐门',
    englishTitle: 'Soul Land 2',
    category: 'anime',
    subcategory: '动画剧集',
    year: 2026,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20series%20poster%2C%20fantasy%20martial%20arts%20characters%20with%20glowing%20spirit%20rings%2C%20dynamic%20action%20pose%2C%20blue%20and%20gold%20magical%20effects%2C%20donghua%20animation%20style%2C%20epic%20poster%20design&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20animation%20landscape%2C%20floating%20islands%20with%20waterfalls%2C%20magical%20glowing%20auras%2C%20martial%20arts%20academy%20setting%2C%20vibrant%20colors%2C%20cinematic%20wide%20shot%2C%20donghua%20aesthetic&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    description: '故事发生在斗罗大陆万年之后。新一代史莱克七怪集结，霍雨浩肩负使命，在史莱克学院开启修炼之路。他将与伙伴们一起，面对来自日月帝国的威胁，守护大陆和平。',
    director: '玄机科技',
    actors: ['梁达伟', '唐雅菁', '孙晔', '沈达威'],
    region: '中国大陆',
    duration: '22分钟/集',
    episodes: '更新至52集',
    releaseDate: '2026-01-10',
    tags: ['动画', '玄幻', '热血', '战斗'],
    isHot: true,
    isNew: false,
    views: 15200000,
  },
  {
    id: 8,
    title: '庆余年 第三季',
    englishTitle: 'Joy of Life S3',
    category: 'tv',
    subcategory: '古装',
    year: 2026,
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20elegant%20figure%20in%20traditional%20robes%20holding%20sword%2C%20ancient%20Chinese%20palace%20background%2C%20dramatic%20lighting%2C%20cinematic%20TV%20series%20poster%20design&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20at%20sunset%2C%20traditional%20architecture%2C%20dramatic%20sky%2C%20golden%20hour%20lighting%2C%20cinematic%20wide%20shot%2C%20historical%20drama%20aesthetic&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    description: '范闲在北齐归来后，面对更加复杂的朝堂斗争。庆帝的心思愈发难测，陈萍萍的秘密逐渐浮出水面。在这盘大棋中，范闲将如何抉择，又能否守护住自己珍视的一切？',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    duration: '50分钟/集',
    episodes: '36集',
    releaseDate: '2026-06-18',
    tags: ['古装', '权谋', '武侠', '剧情'],
    isHot: true,
    isNew: true,
    views: 11340000,
  },
  {
    id: 9,
    title: '向往的生活 第九季',
    englishTitle: 'Back to Field S9',
    category: 'variety',
    subcategory: '生活纪实',
    year: 2026,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20TV%20show%20poster%2C%20peaceful%20countryside%20farmhouse%20with%20green%20fields%2C%20warm%20sunlight%2C%20natural%20lifestyle%20aesthetic%2C%20cozy%20atmosphere%2C%20entertainment%20poster%20design&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20landscape%20with%20traditional%20farmhouse%2C%20green%20rice%20fields%2C%20mountains%20in%20distance%2C%20golden%20sunset%20light%2C%20peaceful%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    description: '黄磊和何炅带领新老朋友们，来到云南大理的苍山洱海之间，开启新一季的田园生活。在这里，他们自己动手，丰衣足食，与自然和谐共处，招待远道而来的朋友。',
    director: '湖南卫视',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    region: '中国大陆',
    duration: '100分钟/期',
    episodes: '14期',
    releaseDate: '2026-04-25',
    tags: ['综艺', '生活', '美食', '田园'],
    isHot: false,
    isNew: true,
    views: 5210000,
  },
  {
    id: 10,
    title: '三体：黑暗森林',
    englishTitle: 'Three-Body: The Dark Forest',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Hard%20sci-fi%20movie%20poster%2C%20cosmic%20dark%20forest%20concept%2C%20mysterious%20universe%20with%20distant%20stars%2C%20minimalist%20design%2C%20deep%20space%20aesthetic%2C%20philosophical%20sci-fi%20film%20poster&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Deep%20space%20cosmic%20landscape%20with%20galaxies%20and%20nebula%2C%20mysterious%20dark%20universe%2C%20stars%20scattered%20across%20infinite%20darkness%2C%20philosophical%20sci-fi%20aesthetic%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    description: '面对三体舰队的入侵威胁，人类启动"面壁计划"。四位面壁者各自制定对抗策略，而三体世界则派出"破壁人"一一破解。在这场跨越光年的博弈中，罗辑发现了宇宙的黑暗森林法则。',
    director: '张艺谋',
    actors: ['张译', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    duration: '168分钟',
    episodes: '1集',
    releaseDate: '2026-07-15',
    tags: ['科幻', '悬疑', '哲学', '硬科幻'],
    isHot: true,
    isNew: true,
    views: 10120000,
  },
  {
    id: 11,
    title: '长安十二时辰 第二季',
    englishTitle: 'The Longest Day In Chang\'an S2',
    category: 'tv',
    subcategory: '古装',
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20drama%20poster%2C%20Tang%20Dynasty%20warrior%20in%20armor%2C%20ancient%20city%20at%20night%20with%20lanterns%2C%20tense%20atmosphere%2C%20cinematic%20poster%20design&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20city%20at%20night%20with%20red%20lanterns%2C%20bustling%20market%20street%2C%20traditional%20Chinese%20architecture%2C%20atmospheric%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    description: '天宝三年，上元节前夕，长安城再次陷入危机。张小敬与李必再度联手，必须在十二个时辰内阻止一场危及全城百姓的阴谋。时间紧迫，敌人藏于暗处，这场生死较量将比上一次更加惊心动魄。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    duration: '50分钟/集',
    episodes: '24集',
    releaseDate: '2026-03-08',
    tags: ['古装', '悬疑', '动作', '历史'],
    isHot: false,
    isNew: true,
    views: 3890000,
  },
  {
    id: 12,
    title: '奔跑吧 第十四季',
    englishTitle: 'Keep Running S14',
    category: 'variety',
    subcategory: '户外真人秀',
    year: 2026,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20sunny%20day%2C%20energetic%20and%20fun%20atmosphere%2C%20colorful%20design%2C%20entertainment%20poster&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20sunny%20outdoor%20park%20with%20obstacle%20course%2C%20colorful%20game%20set%20pieces%2C%20fun%20energetic%20atmosphere%2C%20wide%20angle%20shot%2C%20entertainment%20production%20photography&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    description: '跑男团再度出发，全新一季开启全国奔跑之旅。李晨、郑恺、沙溢等老成员携手新加入的年轻血液，在各地展开趣味横生的游戏挑战。欢笑不断，温情满满，这个夏天让我们一起奔跑吧！',
    director: '浙江卫视',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    region: '中国大陆',
    duration: '100分钟/期',
    episodes: '12期',
    releaseDate: '2026-04-18',
    tags: ['综艺', '户外', '游戏', '搞笑'],
    isHot: false,
    isNew: true,
    views: 4760000,
  },
];

export const banners = movies.filter(m => m.isHot).slice(0, 5);

export const hotMovies = movies.filter(m => m.isHot).sort((a, b) => b.views - a.views);

export const newMovies = movies.filter(m => m.isNew).sort((a, b) => b.year - a.year || b.rating - a.rating);

export const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

export function getMoviesByCategory(categoryId: string): Movie[] {
  return movies.filter(m => m.category === categoryId);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 4): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && (m.category === movie.category || m.subcategory === movie.subcategory))
    .slice(0, count);
}